import type { Token } from 'src/shared/graphql';

export const decodeJwt = (token: Token): object => {
  if (!token) return {};

  let decodedJwt: object;

  try {
    decodedJwt = JSON.parse(atob(token.split('.')[1])) as object;
  } catch (e) {
    decodedJwt = {};
  }

  return decodedJwt;
};
